import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=446d19b8&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260826170951/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446d19b8')) {
      api.createRecord('446d19b8', component.options)
    } else {
      api.reload('446d19b8', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=446d19b8&", function () {
      api.rerender('446d19b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/form/slider.vue"
export default component.exports